module.exports = __webpack_public_path__ + "media/images/wines/muscat-petit-grain/bottle-c769e936e422e84be5292efd9185ad7c.png";